//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { OPERATION_TYPES } from '@/utils/constant';
export default {
  props: {
    rules: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      },
    },
    roles: {
      type: Array,
      default: () => [],
    },
    posts: {
      type: Array,
      default: () => [],
    },
    externalParam: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OPERATION_TYPES,
      sw: true,
    };
  },
  computed: {
    item: {
      get() {
        return this.value;
      },
      set(value) {
        this.save(value);
      },
    },
    valueTypes() {
      if (['EXIST', 'NOT_EXIST'].includes(this.item.operation)) {
        return { SQL: '子查询' };
      }

      const types = {};

      if (!['IN', 'NIN'].includes(this.item.operation)) {
        types.CONST = '常量';
      }

      types.VAR = '变量';

      if (this.item.operation === '' || ['IN', 'NIN'].includes(this.item.operation)) {
        types.SQL = '子查询';
      }

      if (this.externalParam) {
        types.PARAM = '外部参数';
      }
      return types;
    },
    varTypes() {
      if (['ANY', ''].includes(this.item.operation)) {
        return [
          { value: '$_uin', label: '用户uin' },
          { value: '$_uin_sub_all', label: '本人及下属' },
          { value: '$_territory', label: '岗位code' },
          { value: '$_territory_all', label: '本岗位及下属岗位' },
          { value: '$_org', label: '组织code' },
          { value: '$_org_all', label: '本组织及下属组织' },
          { value: '$_ext_role', label: '角色' },
          { value: '$_ext_territory', label: '岗位' },
        ];
      }
      if (['IN', 'NIN'].includes(this.item.operation)) {
        return [
          { value: '$_uin_sub_all', label: '本人及下属' },
          { value: '$_territory_all', label: '本岗位及下属岗位' },
          { value: '$_org_all', label: '本组织及下属组织' },
          { value: '$_ext_role', label: '角色' },
          { value: '$_ext_territory', label: '岗位' },
        ];
      }
      return [
        { value: '$_uin', label: '用户uin' },
        { value: '$_territory', label: '岗位code' },
        { value: '$_org', label: '组织code' },
      ];
    },
  },
  methods: {
    operationChange() {
      if (['EXIST', 'NOT_EXIST'].includes(this.item.operation)) {
        this.item.field = '';
      }
      if (['IN', 'NIN'].includes(this.item.operation)) {
        switch (this.item.value.type) {
          case 'SQL':
            return;
          case 'VAR':
            if (this.item.value.value !== '$_territory_all') {
              this.item.value.value = '$_territory_all';
            }
            return;
          case 'CONST':
            this.item.value.type = '';
            return;
          default:
            return;
        }
      }
      switch (this.item.value.type) {
        case 'SQL':
          this.item.value.type = '';
          return;
        case 'VAR':
          if ('$_territory_all' === this.item.value.value) {
            this.item.value.value = '$_uin';
          }
          return;
        case 'CONST':
          return;
        default:
          return;
      }
    },
    typeChange() {
      if (this.item.value.type === 'PARAM') {
        this.item.value.value = '?';
      } else {
        this.item.value.value = '';
      }
    },
    valueChange() {
      if (['$_uin', '$_territory', '$_territory_all'].includes(this.item.value.value)) {
        delete this.item.value.ext_value;
      }
      if (['$_ext_role', '$_ext_territory'].includes(this.item.value.value)) {
        this.item.value.ext_value = [];
      }
      this.item = JSON.parse(JSON.stringify(this.item));
      this.sw = false;
      this.$nextTick(() => {
        this.sw = true;
      });
    },
    save(data) {
      this.$emit('change', data);
    },
  },
};
